export default "__VITE_ASSET__mVlHK3QO__"